import { createSlice } from '@reduxjs/toolkit';
import { IUserState } from '../../types/user';

const initialState: IUserState = {};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserPhoneNumber(state, action) {
      state.phoneNumber = action.payload;
    },
  },
});

export const {
  reducer: userReducer,
  actions: { setUserPhoneNumber },
} = userSlice;
